import { useMemo } from 'react';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import classes from './Pagination.module.scss';

const Pagination = ({ dataCount }) => {
	const router = useRouter();
	const [page, setPage] = useState(() => router.query.page || 1);
	const [pageSize] = useState(() => router.query.page_size || 10);
	const pagesNumbers = useMemo(
		() => dataCount && Array.from(Array(Math.ceil(dataCount / pageSize)), (_, i) => i + 1),
		[dataCount, pageSize]
	);

	const setPageHandler = (pageNum) => {
		setPage(pageNum);
		router.replace({
			pathname: router.pathname,
			query: {
				...router.query,
				page: pageNum,
				page_size: pageSize
			}
		});
	};

	useEffect(() => {
		if (router.isReady && !page && !pageSize) {
			router.replace({
				pathname: router.pathname,
				query: {
					...router.query,
					page: pageNum,
					page_size: pageSize
				}
			});
		}
	}, []);

	return (
		<>
			{pagesNumbers?.length > 1 && (
				<div
					className={`${classes['pagination-button']} d-flex flex-row justify-content-center gap-2`}>
					{pagesNumbers.map((pageNumber) => (
						<button
							key={pageNumber}
							onClick={() => setPageHandler(pageNumber)}
							disabled={pageNumber === +page}>
							{pageNumber}
						</button>
					))}
				</div>
			)}
		</>
	);
};

export default Pagination;
